import { render, staticRenderFns } from "./Oauth3rdRedirect.vue?vue&type=template&id=4b405c52&scoped=true&"
import script from "./Oauth3rdRedirect.vue?vue&type=script&lang=js&"
export * from "./Oauth3rdRedirect.vue?vue&type=script&lang=js&"
import style0 from "./Oauth3rdRedirect.vue?vue&type=style&index=0&id=4b405c52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b405c52",
  null
  
)

export default component.exports